import React from 'react';
import './App.scss';
import Home from './components/home/home'
import Chat from './components/chat/Chat';
import { db } from './firebase-config'
import { collection, getDocs } from 'firebase/firestore'
import Form from './admin/components/form/form';
import { Route, Routes } from 'react-router-dom';
import InfoForm from './admin/components/infoForm/infoForm';
import ProjectList from './admin/components/projectList/projectList';
import TechnicalSkillList from './admin/components/technicalSkillsList/technicalSkillList';
import TimelineList from './admin/components/timelineList/timelineList';
import Constants from './constants';
export class App extends React.Component<any, any, any> {
  userCollectionRef = collection(db, "portfolio")
  profileData: any = [];

  constructor(props: any) {
    super(props);
    this.state = {
      data: {}
    }
  }


  async componentDidMount() {
    const querySnapshot: any = await getDocs(this.userCollectionRef)

    querySnapshot.forEach((doc) => {
      this.profileData.push(doc.data())
    });

    this.setState({
      data: this.profileData[0]
    })

  }


  render(): React.ReactNode {
    let home;
    if (this.profileData[0]) {
      home = <Home profileData={this.profileData[0]}></Home>
    }
    return (
      <div className="App">
      <Routes>
        {/* <switch> */}
        <Route path='/' element={home} />
        <Route  path='/header-option' element={<Form></Form>} />
        <Route path='/info-list' element={<InfoForm></InfoForm>} />
        <Route path='/project-list' element={<ProjectList></ProjectList>} />
        <Route path='/technical-skill-list' element={<TechnicalSkillList></TechnicalSkillList>} />
        <Route path='/timeline-list' element={<TimelineList  timeLineType={Constants.timeLineEducationType} />} />
        <Route path='/chat' element={<Chat />} />
        {/* </switch> */}
      </Routes>
      </div>
    );
  }

}

export default App;
